import Image from "next/image";
import styles from "./Section9.module.scss";

export const Section9 = function () {
  return (
    <section id="usp" className={`${styles.container} cc--component-container`}>
      <section className={styles.content}>
        <h3 className={styles.headline}>AN ONLINE EDUCATION THAT SETS YOU APART</h3>
        <span className={styles.subHeadline}>
          This MIT online short course is delivered in collaboration with online education provider GetSmarter. Join a
          growing community of global professionals who have already had the opportunity to:
        </span>
        <section className={styles.props}>
          <div className={styles.prop}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/03/a6e74f99-cert_02w02w02w02w000000001.png"
              alt=""
              height={80}
              width={80}
            />
            <span>
              Gain verifiable and relevant competencies and earn invaluable recognition from an{" "}
              <strong>international selection of universities</strong>, entirely online and in your own time
            </span>
          </div>
          <div className={styles.prop}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/03/b71c0230-mitsloan-icons-personal_02w02w02w02w000000001.png"
              alt=""
              height={80}
              width={80}
            />
            <span>
              Enjoy a <strong>personalized, people-mediated</strong> online learning experience created to make you feel
              supported at every step
            </span>
          </div>
          <div className={styles.prop}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/03/690f3b58-briefcase_02w02w02w02w000000001.png"
              alt=""
              height={80}
              width={80}
            />
            <span>
              Experience a <strong>flexible but structured approach</strong> to online education as you plan your
              learning around your life to meet weekly milestones
            </span>
          </div>
        </section>
      </section>
    </section>
  );
};
